import React from 'react';

import { INTEGRATION_THEME } from 'constants/index';
import app from 'components/app';
import Page from 'components/Page';
import Section from 'components/Page/Section';
import Wrapper from 'components/Page/Wrapper';
import H1 from 'components/typo/Heading/H1';
import H2 from 'components/typo/Heading/H2';
import P from 'components/typo/P';
import {
  PLATFORMS,
  INTEGRATION_PRODUCTS,
} from 'components/Navigation/constants';
import ContactForm from 'components/ContactForm';
import { useTranslation } from 'lib/i18n';

import { jumbotron } from '../home/styles';

import Platforms from './Platforms';
import Products from './Products';
import DocsTopImage from './DocsTopImage';
import peopleImage from './images/Oliver_developer.svg';
import { DocsProps } from './types';

const DocsIndex: React.FC<DocsProps> = props => {
  const { t } = useTranslation('pages');

  return (
    <>
      <Page title={t('integration.title')} footer noPadding scrollingHeader>
        <>
          <Section css={jumbotron} headerColor beforeWave>
            <Wrapper>
              <>
                <H1>{t('integration.h1')}</H1>
                <P>{t('integration.description')}</P>
                <DocsTopImage
                  src={peopleImage}
                  style={{ transform: 'scale(0.94)' }}
                />
              </>
            </Wrapper>
          </Section>
          <Section
            id={PLATFORMS}
            topWave
            white
            css="padding: 50px 0 40px 0 !important"
          >
            <Wrapper>
              <Platforms />
            </Wrapper>
          </Section>
          <Section id={INTEGRATION_PRODUCTS} white>
            <Wrapper>
              <Products />
            </Wrapper>
          </Section>
          <Section white>
            <Wrapper>
              <>
                <H2>{t('integration.contactUs.title')}</H2>
                <ContactForm
                  organizationsDemo={
                    props.url.query.organizationsDemo !== undefined
                  }
                />
              </>
            </Wrapper>
          </Section>
        </>
      </Page>
    </>
  );
};

export default app(DocsIndex, {
  theme: INTEGRATION_THEME,
});
